import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'hour4u-admin-help-videos',
  templateUrl: './help-videos.component.html',
  styleUrls: ['./help-videos.component.scss']
})
export class HelpVideosComponent implements OnInit {
  videos: { url: string, title: string }[] = [];

  constructor(private router: Router) {
    // Assign the video URLs and titles to the videos array
    this.videos = [
      { url: 'https://image-data-hour4u-2.s3.ap-south-1.amazonaws.com/2.mp4', title: '1. How to Rank Resumes with AI.' },
      { url: 'https://image-data-hour4u-2.s3.ap-south-1.amazonaws.com/3.mp4', title: '2. How to Run interviews on auto pilot.' },
      { url: 'https://image-data-hour4u-2.s3.ap-south-1.amazonaws.com/4.mp4', title: '3. How to invite someone & win referrals.' }
    ];
  }

  ngOnInit() {
  }

}
